import React, { Suspense, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import {
  Accordion
} from "react-accessible-accordion";
import { encodeUrl } from "../../../lib/encode-url";
import { calculateCollapseHeight } from "../../../lib/calculate-collape-height";
import classNames from "classnames";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import TeaserVenueStructureStandard from "@default/teasers/venue/components/teaser-venue-structure-standard";
import TeaserVenueStructureSimple from "@default/teasers/venue/components/teaser-venue-structure-simple";

const TeaserVenue = ({ item, updateUrl, index }) => {
  const teaser = useRef();
  const { simpleDesign } = useAccessibilityContext();
  const location = useLocation();

  const preExpand = (() => {
    if (item && encodeUrl(item.label) === location?.hash.replace("#", "")) {
      return [item.id];
    }
    return [];
  })();

  const updateAccordion = () => {
    if (updateUrl && teaser.current) {
      let scrollPosition =
        teaser.current.getBoundingClientRect().top + window.scrollY - 150;

      history.pushState(
        null,
        window.location.pathname,
        `#${encodeUrl(item.label)}`
      );

      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    // Timeout is only set because the "todoerror" below forces a re rendering, can be removed after error is fixed
    setTimeout(() => {
      calculateCollapseHeight(teaser.current);
    }, 500);

    if (item && encodeUrl(item.label) === location.hash.replace("#", "")) {
      setTimeout(() => {
        updateAccordion();
      }, 500);
    }
  }, []);

  const teaserClassNames = classNames({
    "node node-teaser teaser-venue venue-element": true,
    "with-image": item.fieldImage,
    "no-image": !item.fieldImage,
  });

  return (
    <article
      className={teaserClassNames}
      ref={teaser}
      id={encodeUrl(item.label)}
      data-to-scrollspy-id={encodeUrl(item.label)}
      data-teaser-index={index}
    >
      {simpleDesign ? (
        <TeaserVenueStructureSimple
          item={item}
          expanded={true}
        />
      ) : (
        <Suspense fallback={<div></div>}>
          <Accordion
            allowZeroExpanded={true}
            onChange={() => updateAccordion()}
            preExpanded={preExpand}
          >
            <TeaserVenueStructureStandard
              item={item}
            />
          </Accordion>
        </Suspense>
      )}
    </article>
  );
};

export const teaserVenuePropTypes = PropTypes.shape({
  id: PropTypes.string,
  activeBefore: PropTypes.bool,
  title: PropTypes.string,
  path: PropTypes.shape({
    alias: PropTypes.string,
  }),
  url: PropTypes.shape({
    path: PropTypes.string,
  }),
  fieldImage: PropTypes.shape({
    fieldMediaImage: PropTypes.shape({
      alt: PropTypes.string,
      title: PropTypes.string,
      style: PropTypes.shape({
        url: PropTypes.string,
      }),
    }),
  }),
});

TeaserVenue.propTypes = {
  item: teaserVenuePropTypes,
  updateUrl: PropTypes.bool,
  index: PropTypes.number,
};

export default TeaserVenue;
